import type { CustomDomain } from './customDomainsApi.types';

export const CUSTOM_DOMAIN_POLL_INTERVAL_MILLISECONDS = 10000;

export function isCustomDomainSettled(customDomain: CustomDomain): boolean {
  return customDomain.status === 'active' || customDomain.status === 'disabled';
}

export function resolveCustomDomainRefetchInterval(
  customDomains: CustomDomain[] | undefined
): number | false {
  if (customDomains === undefined) {
    return false;
  }
  const hasUnsettledDomain = customDomains.some(function isUnsettled(customDomain) {
    return isCustomDomainSettled(customDomain) === false;
  });
  return hasUnsettledDomain ? CUSTOM_DOMAIN_POLL_INTERVAL_MILLISECONDS : false;
}
